<template>
  <div class="loading" v-if="isShow.isLDShow">
    <div class="progress-bar-wp">
      <div class="gif-wp">
        <img
          src="./img/ld-person.gif"
          alt=""
          :style="{transform: `translateX(${2.4 * loadingNum}px)` }"
        />
      </div>
      <div class="progress-bar">
        <div class="progress-bar-inner" :style="`width: ${loadingNum}%;`"></div>
        <span class="progress-text_num">{{ loadingNum }}%</span>
      </div>
      <div class="progress-text">{{ loadingTxt }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Object,
  },
  data() {
    return {
      loadingTxt: '文明创建为民利民 文明城市共建共享',
      loadingNum: 0,
      preLoadImg: [
        { src: require('../../pages/page-four/img/fn-avatar.png') },
        { src: require('../../pages/page-four/img/fn-bottom-txt.jpg') },
        { src: require('../../pages/page-four/img/fn-header.png') },
        { src: require('../../pages/page-four/img/fn-logo.png') },
        { src: require('../../pages/page-four/img/fn-qr.png') },
        { src: require('../../pages/page-four/img/fn-title.png') },
        { src: require('../../pages/page-kv/img/kv-100.png') },
        { src: require('../../pages/page-kv/img/kv-flower-empty.png') },
        { src: require('../../pages/page-kv/img/kv-flower-full.png') },
        { src: require('../../pages/page-kv/img/kv-left.jpg') },
        { src: require('../../pages/page-kv/img/kv-logo.png') },
        { src: require('../../pages/page-kv/img/kv-title1.png') },
        { src: require('../../pages/page-kv/img/kv-title2.png') },
        { src: require('../../pages/page-kv/img/kv-txt.png') },
        { src: require('../../pages/page-one/img/po-flower.png') },
        { src: require('../../pages/page-one/img/po-inputName.png') },
        { src: require('../../pages/page-one/img/po-logo.png') },
        { src: require('../../pages/page-one/img/po-ring.png') },
        { src: require('../../pages/page-one/img/po-select.png') },
        { src: require('../../pages/page-one/img/po-title.png') },
        { src: require('../../pages/page-two/img/pt-complete.png') },
        { src: require('../../pages/page-two/img/pt-cross.png') },
        { src: require('../../pages/page-two/img/pt-header.jpg') },
        { src: require('../../pages/page-two/img/pt-header.png') },
        { src: require('../../components/musicplayer/img/music-off.png') },
        { src: require('../../components/musicplayer/img/music-on.png') },
        { src: require('../../components/rotate/img/rt-direction.png') },
        { src: require('../../components/rotate/img/rt-fail.png') },
        { src: require('../../components/rotate/img/rt-success.png') },
        {
          src:
            _const.host+ _const.path+'/common/logo-sprites.png',
        },
      ],
    }
  },
  methods: {
    generateId(index) {
      return 'mImg' + index
    },
    go() {
      this.$emit('nextPage', 'isKVShow')
    },
    loadNextImg(imgID) {
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt((imgID / len) * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          _this.go()
        }
      }
      curImg.src = curSrc
    },
  },
  mounted() {
    let imgID = 0
    this.loadNextImg(imgID)
  },
}
</script>

<style>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  transform-origin: 50% 50%;
  z-index: 2;
  background-color: #ffe400;
}
.progress-bar-wp {
  position: relative;
  margin-bottom: 14rem;
}
.gif-wp img {
  width: 1.64285714rem /* 92/16 */;
  height: auto;
}
.progress-bar {
  position: relative;
  box-sizing: border-box;
  height: 1.25rem /* 20/16 */;
  width: 17.5rem /* 560/16 */;
  border: 1px solid #1a1a1a;
  border-radius: 1rem;
  margin: 1rem 0 2rem /* 32/16 */ 0;
  background-color: #e6b652;
}
.progress-bar-inner {
  height: 100%;
  background: linear-gradient(to bottom, #ffac01 1%, #ff870b 50%, #ff5e15 100%);
  border-radius: 1rem;
}
.progress-text {
  text-align: center;
  color: #333;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.4;
}
.progress-text_num {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1.3125rem /* 21/16 */;
  margin-top: -0.5rem;
  width: 2.625rem /* 42/16 */;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.625rem /* 10/16 */;
  color: #efefef;
  text-shadow: 0 0 3px rgba(51, 50, 50, 0.4);
}

</style>
